import { render } from "./DirectorioMemberStreamlined.vue?vue&type=template&id=2bee937a&scoped=true"
import script from "./DirectorioMemberStreamlined.vue?vue&type=script&lang=ts"
export * from "./DirectorioMemberStreamlined.vue?vue&type=script&lang=ts"

import "./DirectorioMemberStreamlined.vue?vue&type=style&index=0&id=2bee937a&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-2bee937a"

export default script